<div class="scanner"
     appHIDScanner
     (scannerEvent)="onScan($event)"
     (invalidBadge)="onError($event)">
    <img class="icon" [src]="scanAnimation"/>
    <div class="message"
         [class.focused]="focused"
         [class.blurred]="!focused">
        {{ scanMessage }}
    </div>
</div>
